import * as React from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import clsx from "clsx";
import { Typography, CardContent, Divider } from "@mui/material";

interface Props {
  title: string;
  id: string;
  children: React.ReactNode;
}

interface CardList {
  itemValue: string | number;
  className?: string;
  itemLabel?: string;
  itemValueId?: string;
}

const useStyle = makeStyles(theme => ({
  card: {
    "marginTop": 24,
    "marginBottom": 12,
    "borderRadius": 6,
    "border": "1px solid #acc8df",
    "box-shadow": "0px 0px 10px #D9E8F6",
    "& .MuiTypography-body1": {
      lineHeight: "1rem",
    },
    "&:focus-visible": {
      boxShadow:
        "0px 5px 5px -3px rgba(172,200,223,1), 0px 8px 10px 1px rgba(172,200,223,1), 0px 3px 14px 2px rgba(172,200,223,1)",
    },
  },
  cardTitleHeading: {
    "display": "flex",
    "alignItems": "center",
    "width": "100%",
    "margin": 0,
    "paddingBottom": 16,
    "& .cardTitle": {
      padding: 0,
    },
    "& .MuiGrid-item": {
      padding: 0,
    },
  },
  iconAlign: {
    textAlign: "right",
  },
  listContent: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "row",
    paddingBottom: 0,
    paddingTop: 1,
  },
  listCondensedContent: {
    paddingTop: 0,
    padding: 0,
  },
  listLabel: {
    textAlign: "left",
    width: "100%",
    height: "100%",
    fontWeight: "bolder",
  },
  listValue: {
    width: "100%",
    color: "#666666",
  },
  columnContainer: {
    marginTop: 8,
  },
}));

export function CardListCondensedItem(props: CardList) {
  const classes = useStyle(useTheme());
  return <>
    {props.itemLabel ? (
      <Typography
        display="block"
        component="div"
        color="primary"
        aria-label={`${props.itemLabel}.`}
        className={
          props.className
            ? clsx(props.className, classes.listLabel)
            : classes.listLabel
        }
        id={`item-label-${props.itemLabel} value`.replace(/[^A-Z0-9]/gi, "_")}
      >
        {props.itemLabel}
      </Typography>
    ) : (
      ""
    )}
    <Typography
      display="block"
      component="div"
      className={classes.listValue}
      aria-label={`${props.itemValue}.`}
      id={`item-value-${
        props.itemValueId ? props.itemValueId : props.itemLabel
      } value`.replace(/[^A-Z0-9]/gi, "_")}
    >
      {props.itemValue}
    </Typography>
  </>;
}

export default function SearchResultCard({ children, title, id }: Props) {
  const classes = useStyle(useTheme());

  return (
    <Card
      id={id}
      raised
      tabIndex={0}
      key={`card-${id}`}
      className={clsx(classes.card, "searchResultCard")}
    >
      <CardContent>
        <Typography
          variant="h6"
          display="inline"
          component="span"
          aria-label={`${title}.`}
          color="primary"
          className={clsx("instName", classes.cardTitleHeading)}
        >
          {title}
        </Typography>
        <Typography component="div">
          <Divider />
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
}
